/**
 * Permissions Plugin
 *
 * Provides global permission checking functionality throughout the Nuxt app.
 *
 * Usage:
 *
 * In templates:
 * <div v-if="$permissions.hasPermission('connect-whatsapp')">...</div>
 * <div v-if="$hasPermission('manage-users')">...</div>
 *
 * In composables/pages:
 * const { $hasPermission, $can } = useNuxtApp()
 * if ($hasPermission('edit-roles')) { ... }
 *
 * Via provide/inject:
 * const hasPermission = inject('hasPermission')
 * const can = inject('can')
 */
export default defineNuxtPlugin((nuxtApp) => {
  const { user } = storeToRefs(useAuthStore())

  const permissions = computed(() => user.value?.role?.permissions || [])

  const permissionsAPI = usePermissions(permissions)

  nuxtApp.vueApp.config.globalProperties.$permissions = permissionsAPI

  // @ts-expect-error forced augmentation
  nuxtApp.vueApp.permissions = permissionsAPI

  return {
    provide: {
      permissions: permissionsAPI,
      hasPermission: permissionsAPI.hasPermission,
      hasAnyPermission: permissionsAPI.hasAnyPermission,
      hasAllPermissions: permissionsAPI.hasAllPermissions,
      hasRole: permissionsAPI.hasRole,
      hasAnyRole: permissionsAPI.hasAnyRole,
      hasAllRoles: permissionsAPI.hasAllRoles,
      can: permissionsAPI.can,
    },
  }
})
